import { Grid, Typography } from '../../../../basics/';

interface NoResultPlaceholderProps {
  placeHolderMessage: string;
  placeHolderSubtitle?: string;
  NoResultIcon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export const NoResultPlaceholder = ({
  placeHolderMessage,
  placeHolderSubtitle,
  NoResultIcon,
}: NoResultPlaceholderProps) => {
  return (
    <Grid style={{ alignItems: 'center', display: 'flex', flexDirection: 'column', marginTop: 5, marginBottom: 15 }}>
      <NoResultIcon height={40} width={40} />
      <Typography style={{ fontSize: 14, fontStyle: 'normal', fontWeight: 600, letterSpacing: 0, marginTop: 5 }}>
        {placeHolderMessage}
      </Typography>
      <Typography style={{ fontSize: 14, fontStyle: 'normal', letterSpacing: 0, marginTop: 5 }}>
        {placeHolderSubtitle}
      </Typography>
    </Grid>
  );
};
